export const dataTypes = {
    MEETING_PLACES: "meetingPlaces",
    COUNTRIES: "countries",
    PHONE_PREFIXES: "phonePrefixes",
}